import { Component, Input, OnInit } from '@angular/core';

import { RestaurantService } from './restaurant.service';

import { Restaurant } from './restaurant';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'timetable-location',
	templateUrl: './timetable-location.component.html',
	styleUrls: ['./timetable-location.component.css']
})

export class TimetableLocationComponent implements OnInit {

	constructor(
		private m_restaurant_service: RestaurantService,
  	) {}
	m_restaurant: Restaurant;
	lat: number = 1.293396;
  	lng: number = 103.853462;
 
	ngOnInit(): void {
		this.getRestaurant();
	}

	getRestaurant(): void {
		console.log("TimetableLocationComponent getRestaurant")
		this.m_restaurant_service.getRestaurant(this.m_restaurant_service.name).then(
			restaurant => {
				console.log("TopDetailsComponent callback")
				
				console.log("TopDetailsComponent callback restaurant: " + restaurant.title)
				this.m_restaurant = restaurant;
                               
			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/timetable-location.component.ts